"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityManagerByDevice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("../hooks");
const visibilityManager_1 = require("./visibilityManager");
const VisibilityManagerByDevice = ({ children, hideOn }) => {
    const currentDevice = (0, hooks_1.useCurrentDevice)();
    return ((0, jsx_runtime_1.jsx)(visibilityManager_1.VisibilityManager, { hideOn: hideOn, currentValue: currentDevice, children: children }));
};
exports.VisibilityManagerByDevice = VisibilityManagerByDevice;
//# sourceMappingURL=visibilityManagerByDevice.js.map